import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { EntitlementList } from './entitlement.model';

export type EntitlementSource = Observable<EntitlementList>;

export const ENTITLEMENT_SOURCE = new InjectionToken<EntitlementSource>('Entitlement Source');
